function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  "data-name": "Intersection 8",
  d: "M88.2 692C33 619.106 0 526.635 0 426 0 190.726 180.429 0 403 0s403 190.726 403 426c0 100.635-33 193.106-88.2 266z",
  fill: "#f9d0dc",
  opacity: 0.31
});
var SvgPinkPartialCircle = function SvgPinkPartialCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 806 692"
  }, props), _ref);
};
export default SvgPinkPartialCircle;